export var SurpriseBoxProductValidationErrorTypeEnum;
(function (SurpriseBoxProductValidationErrorTypeEnum) {
    SurpriseBoxProductValidationErrorTypeEnum["ProductNotFound"] = "ProductNotFound";
    SurpriseBoxProductValidationErrorTypeEnum["ProductWasArchived"] = "ProductWasArchived";
    SurpriseBoxProductValidationErrorTypeEnum["ProductCountIsNotEnough"] = "ProductCountIsNotEnough";
    SurpriseBoxProductValidationErrorTypeEnum["ProductPriceWasChanged"] = "ProductPriceWasChanged";
})(SurpriseBoxProductValidationErrorTypeEnum || (SurpriseBoxProductValidationErrorTypeEnum = {}));
